import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const ModalConfirmacaoUpload = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    className="dialog-conta modal-confirmacao-upload"
  >
    <DialogTitle className="titulo-modal">Documentos enviados com sucesso</DialogTitle>

    <DialogContent className="dialog-conta__content">
      <Typography variant="body2" className="dialog-conta__subtitle">
        Nossa equipe irá analisar o material enviado e irá reanalisar a solicitação de crédito em até 3h.
      </Typography>
    </DialogContent>

    <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
      <Button variant="contained" onClick={onClose} className="dialog-conta__btn-escolher">
        Ok
      </Button>
    </DialogActions>
  </Dialog>
);

export default ModalConfirmacaoUpload;
